<mat-grid-list cols="1" rowHeight="600px" class="sm-load-mask">
  <mat-grid-tile>
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </mat-grid-tile>
</mat-grid-list>